<div class="flex flex-col items-center justify-center h-full">
	@if (!isConnected_()) {
		<app-pulse-loader
			imagePath="/assets/images/integrations/sign-it/sign-it-badge.svg"
			altText="SignIT Logo"
		/>
	} @else {
		<i-tabler name="circle-check" class="w-12 h-12 text-green-600"></i-tabler>
	}
	<p class="text-lg text-gray-500 mt-12">
		{{ isConnected_() ? 'Connected' : 'Connecting' }} to SignIT
	</p>
</div>
